import React, { useEffect, useState, useRef } from 'react'
import '.././App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc, getAggregateFromServer, where, sum } from 'firebase/firestore'
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  IconButton,
  Grid
} from "@mui/material";

import ReplyIcon from "@mui/icons-material/Reply";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";


export default function CustomerAccount() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const printRef = useRef();

  const [userData, setUserData] = useState();
  const [customers, setcustomers] = useState([]);
  const [payhistory, setpayhistory] = useState([]);

  const [searchText, setsearchText] = useState("");
  const [name, setname] = useState("");
  const [mobile, setmobile] = useState("");
  const [address, setaddress] = useState("");

  const [totalamount, settotalamount] = useState("0");
  const [previuspaid, setpreviuspaid] = useState("0");
  const [currentpaid, setcurrentpaid] = useState("0");
  const [remaining, setremaining] = useState("0");
  const [remaining1, setremaining1] = useState("0");
  const [paytype, setpaytype] = useState("");
  const [paidDate, setpaidDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [propertyId, setPropertyId] = useState(null);
  const [paymentModes, setPaymentModes] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);

  const [updocid, setupdocid] = useState("");

  useEffect(() => {
    if (!propertyId) return;

    if (searchText === "") {
      fetchData1();
    } else {
      fetchData2();
    }
  }, [searchText, propertyId]);

  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(
        collection(db, "restopaymodes"),
        where("propertyId", "==", propertyId)
      ),
      (snap) =>
        setPaymentModes(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  useEffect(() => {
    const fetchPropertyId = async () => {
      if (!auth.currentUser) return;

      const roleRef = doc(db, "authroles", auth.currentUser.uid);
      const roleSnap = await getDoc(roleRef);

      if (roleSnap.exists()) {
        setPropertyId(roleSnap.data().propertyId);
      } else {
        Toast.fire({ icon: "error", title: "Role not found" });
      }
    };

    fetchPropertyId();
  }, []);




  const fetchData1 = async () => {
    try {
      const q1 = query(
        collection(db, "restocustomers"),
        where("propertyId", "==", propertyId),
        orderBy("created", "desc")
      );

      onSnapshot(q1, async (querySnapshot1) => {
        const combinedData = [];

        for (const doc1 of querySnapshot1.docs) {

          const paidQ = query(
            collection(db, "customeracchistory"),
            where("custid", "==", doc1.id),
            where("propertyId", "==", propertyId)
          );

          const paidSnap = await getAggregateFromServer(paidQ, {
            paid: sum("paid"),
          });

          const orderQ = query(
            collection(db, "orders"),
            where("customerid", "==", doc1.id),
            where("propertyId", "==", propertyId)
          );

          const orderSnap = await getAggregateFromServer(orderQ, {
            totalamount: sum("totalamount"),
          });

          const discQ = query(
            collection(db, "customeracchistory"),
            where("custid", "==", doc1.id),
            where("propertyId", "==", propertyId)
          );

          const discSnap = await getAggregateFromServer(discQ, {
            discount: sum("discount"),
          });

          combinedData.push({
            id: doc1.id,
            data: doc1.data(),
            totalamount: orderSnap.data().totalamount || 0,
            discount: discSnap.data().discount || 0,
            paid: paidSnap.data().paid || 0,
            remaining:
              (orderSnap.data().totalamount || 0) -
              (discSnap.data().discount || 0) -
              (paidSnap.data().paid || 0),
          });
        }

        setcustomers(combinedData);
      });
    } catch (error) {
      Toast.fire({ icon: "error", title: error.message });
    }
  };


  const fetchData2 = async () => {
    try {
      const filteredData = customers.filter((item) =>
        item.data.name.toUpperCase().includes(searchText.toUpperCase())
      );
      setcustomers(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }



  const handleReply = (docid, totalamount, padiamount, remaining) => {
    setupdocid(docid);
    settotalamount(totalamount);
    setpreviuspaid(padiamount);
    setremaining(remaining);
    setremaining1(remaining);

  }

  const handleUpdate = async () => {
    await addDoc(collection(db, "customeracchistory"), {
      custid: updocid,
      propertyId: propertyId,
      userid: auth.currentUser?.uid,
      paiddate: paidDate,
      paid: parseFloat(currentpaid),
      remaining: remaining,
      paytype: paytype,
      status: "Active",
      note: "Paid from the Customer amount",
      created: Timestamp.now(),
    });



    setcurrentpaid(0);
    Toast.fire({
      icon: "success",
      title: 'Customer payment updated successfully!!'
    });

    fetchData1();
  }


  const finaltotal = () => {
    let remainingnew = parseFloat(remaining1) - parseFloat(currentpaid);
    if (remainingnew < 0) {
      Toast.fire({ icon: "error", title: 'Remaining should not be less than 0' });
      setcurrentpaid("");
      setremaining(remaining1);
      return;
    }
    if (currentpaid === '') {
      setremaining(remaining1);
    } else {
      setremaining(remainingnew);
    }
  }

  const handleView = (docid, name, mobile, address) => {
    setname(name);
    setmobile(mobile);
    setaddress(address);
    setOpenHistory(true); // 🔥 MISSING LINE

    const q = query(
      collection(db, "customeracchistory"),
      where("custid", "==", docid),
      where("propertyId", "==", propertyId),
      orderBy("paiddate", "desc")
    );

    onSnapshot(q, (querySnapshot2) => {
      const history = querySnapshot2.docs.map((d) => {
        const data = d.data();
        return {
          id: d.id,
          data: {
            ...data,
            paymodeName: paymentModeMap[data.paytype] || "Unknown",
          },
        };
      });

      setpayhistory(history);
    });
  };



  const paymentModeMap = React.useMemo(() => {
    const map = {};
    paymentModes.forEach(pm => {
      map[pm.id] = pm.paymode;
    });
    return map;
  }, [paymentModes]);


  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  })

  const handleDelete = async (docid) => {
    const taskDocRef = doc(db, 'customeracchistory', docid)
    await deleteDoc(taskDocRef)
    Toast.fire({
      icon: "success",
      title: 'Customer Payment Entry Deleted Successfully!!'
    });
    fetchData1();

  }

  return (
    <div className="p-3">
      <Card>
        <CardContent>
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Customer Account
          </Typography>

          <TextField
            label="Search Customer"
            size="small"
            fullWidth
            value={searchText}
            onChange={(e) => setsearchText(e.target.value)}
            sx={{ mb: 2, maxWidth: 400 }}
          />

          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Sr</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>Discount</TableCell>
                  <TableCell>Paid</TableCell>
                  <TableCell>Remaining</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {customers.map((item, index) => (
                  <TableRow key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.data.name}</TableCell>
                    <TableCell>{item.data.mobile}</TableCell>
                    <TableCell>{item.data.address}</TableCell>
                    <TableCell>₹ {item.totalamount}</TableCell>
                    <TableCell>₹ {item.discount}</TableCell>
                    <TableCell>₹ {item.paid}</TableCell>
                    <TableCell>₹ {item.remaining}</TableCell>

                    <TableCell>
                      <IconButton
                        color="info"
                        onClick={() =>
                          handleReply(
                            item.id,
                            item.totalamount,
                            item.paid,
                            item.remaining
                          )
                        }
                      >
                        <ReplyIcon />
                      </IconButton>

                      <IconButton
                        color="success"
                        onClick={() =>
                          handleView(
                            item.id,
                            item.data.name,
                            item.data.mobile,
                            item.data.address
                          )
                        }
                      >
                        <VisibilityIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>



      {/* ============================================= modal start ================================================= */}

      <Dialog open={Boolean(updocid)} maxWidth="md" fullWidth>
        <DialogTitle>
          Pay Customer Amount
          <IconButton
            onClick={() => setupdocid("")}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid className="row" spacing={2}>
            <Grid className="col-sm-3 mb-3">
              <TextField label="Total Amount" value={totalamount} fullWidth size="small" disabled />
            </Grid>

            <Grid className="col-sm-3 mb-3">
              <TextField label="Previous Paid" value={previuspaid} fullWidth size="small" disabled />
            </Grid>

            <Grid className="col-sm-3 mb-3">
              <TextField
                label="Current Paid"
                value={currentpaid}
                onChange={(e) => setcurrentpaid(e.target.value)}
                onKeyUp={finaltotal}
                fullWidth size="small"
              />
            </Grid>

            <Grid className="col-sm-3 mb-3">
              <TextField label="Remaining" value={remaining} fullWidth size="small" disabled />
            </Grid>

            <Grid className="col-sm-3 mb-3">
              <TextField
                select
                fullWidth size="small"
                label="Payment Mode"
                value={paytype} onChange={(e) => setpaytype(e.target.value)}
              >
                <MenuItem value="">Select Paymode</MenuItem>
                {paymentModes.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.paymode}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>

            <Grid className="col-sm-3 mb-3">
              <TextField
                type="date"
                label="Paid Date"
                InputLabelProps={{ shrink: true }}
                value={paidDate}
                onChange={(e) => setpaidDate(e.target.value)}
                fullWidth size="small"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={handleUpdate}>
            Add Payment
          </Button>
          <Button color="error" onClick={() => setupdocid("")}>
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={openHistory} maxWidth="lg" fullWidth>

        <DialogTitle>Customer Payment History</DialogTitle>

        <DialogContent ref={printRef}>
          <Typography>Name: {name}</Typography>
          <Typography>Mobile: {mobile}</Typography>
          <Typography>Address: {address}</Typography>

          <Table size="small" sx={{ mt: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Paid</TableCell>
                <TableCell>Remaining</TableCell>
                <TableCell>Pay Type</TableCell>
                <TableCell>Note</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {payhistory.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    {moment(item.data.paiddate).format("DD-MM-YYYY")}
                  </TableCell>
                  <TableCell>{item.data.paid}</TableCell>
                  <TableCell>{item.data.remaining}</TableCell>
                  <TableCell>{item.data.paymodeName}</TableCell>
                  <TableCell>{item.data.note}</TableCell>
                  <TableCell>
                    <IconButton color="error" onClick={() => handleDelete(item.id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>

        <DialogActions>
          <Button onClick={handlePrint}>Print</Button>
          <Button
            color="error"
            onClick={() => {
              setOpenHistory(false);
              setpayhistory([]);
            }}
          >
            Close
          </Button>

        </DialogActions>
      </Dialog>

    </div>
  )
}
